/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from 'jotai';
export type Noti = {
  id?: number;
  type?: string;
  message: string;
  fileName: string;
  createdAt?: string;
  isReaded?: boolean;
}
const storedNoti: Noti[] = JSON.parse(localStorage.getItem('Noti') || '[]');

export const NotiAtom = atom(storedNoti);
